import { HuitabModal } from '../../../../shared/components/common/huitab-modal';
import { TagCommanderManager } from '../../../../shared/services/tag-commander-manager';

/**
 * La modale pour afficher les détails d'heures pleines et heures creuses (puissance et période) d'un compteur >36 kvA (non C5)
 */
export default class ModalDetailleeHPHC extends HuitabModal {
  /**
   * Initialise une nouvelle instance de type {@type ModalDetailleeHPHC}.
   */
  constructor() {
    super('modal-detaillee-hp-hc');
    const link = this.qs('#link-en-savoir-plus');
    link?.addEventListener('click', () => this.sendTagEnSavoirPlus());
  }

  show(classesTemporellesPuissanceProgrammeeListeString) {
    /**
     *  Liste des classes temportelles puissance programmee
     *  @type {List<ClassesTemporellesPuissanceProgrammee> listeClassesTemporellesPuissanceProgrammee}
     */
    const listeClassesTemporellesPuissanceProgrammee = JSON.parse(classesTemporellesPuissanceProgrammeeListeString);

    const pointeHeaderRow = this.qs('#hiver-pointe-header-row');
    const pointeValueRow = this.qs('#hiver-pointe-value-row');

    const hiver = listeClassesTemporellesPuissanceProgrammee.find((ctppItem) => ctppItem.typePeriode === 'HIVER');
    const hasPointe = hiver?.programmationHorairePointe || hiver?.puissanceProgrammeePointe;

    if (!hasPointe) {
      if (pointeHeaderRow) pointeHeaderRow.style.display = 'none';
      if (pointeValueRow) pointeValueRow.style.display = 'none';
    }

    const correspondance = ['ete', 'hiver'];
    // On parcourt la liste de classesTemporellesPuissanceProgrammee
    listeClassesTemporellesPuissanceProgrammee.forEach((item, index) => {
      const saison = correspondance[index];
      // On vérifie spécifiquement les clés attendues dans l'affichage
      const expectedKeys = [
        'periodeSaison',
        'programmationHoraireHC',
        'puissanceProgrammeeHC',
        'programmationHoraireHP',
        'puissanceProgrammeeHP',
        'programmationHorairePointe',
        'puissanceProgrammeePointe',
      ];

      expectedKeys.forEach((key) => {
        const el = this.element.querySelector(`#${saison}-${key}`);
        if (!el) return;

        const value = item[key];
        if (value) {
          el.innerHTML = value;
          el.classList.remove('info-non-disponible');
        } else {
          el.innerHTML = 'Non disponible';
          el.classList.add('info-non-disponible');
        }
      });
    });
    super.show();
  }

  qs(selector) {
    return this.element?.querySelector(selector) ?? null;
  }

  sendTagEnSavoirPlus() {
    TagCommanderManager.tagClick({
      chapitre_1: 'mes_compteurs',
      chapitre_2: 'fiche_compteur',
      chapitre_3: 'popup_information_hp_hc',
      page: 'en_savoir_plus',
      type: 'action',
    });
  }
}
